module.exports = __webpack_public_path__ + "img/loader.584b607f.gif";